import React, { useState, useEffect } from "react";
import { message } from "antd";
import dayjs from "dayjs";
import HomeScreenComponent from "../../components/patient/HomeScreenComponent";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { fetchPatientsPL } from "../../apis/patientService";
import { errorMessage } from "../../utils/notificationUtils";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getAllVisitStages } from "../../models/patientSlice";

const HomeScreenContainer = () => {
  const {
    hospital: selectedHospital,
    auth,
    scheme: allSchemes,
    patients: patientData,
  } = useSelector((state: RootState) => state);
  const [todayRegistration, setTodayRegistration] = useState(0);
  const [pendingDocs, setPendingDocs] = useState<any>(0);
  const [patients, setPatients] = useState<any>([]);
  const navigate = useNavigate();
  const [isFetchingPatients, setIsFetchingPatients] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();

  // Simulate API call
  useEffect(() => {
    fetchPatients();
  }, [selectedHospital?.selectedHospital?.value]);

  useEffect(() => {
    dispatch(getAllVisitStages());
  }, []);

  useEffect(() => {
    if (patientData?.visitStages) {
      const preAuth = patientData?.visitStages?.["PreAuth"];
      if(preAuth?.id) {
        fetchPatientsPending(preAuth?.id);
      }
    }
  }, [patientData?.visitStages]);

  const fetchPatientsPending = async (stageId: any) => {
    try {
      if (selectedHospital?.selectedHospital?.value) {
        setIsFetchingPatients(true);
        const res = await fetchPatientsPL(
          {
            orderBy: "DESC",
            pageNumber: "0",
            pageSize: "10",
            endDate: dayjs().format("DD-MM-YYYY"),
            startDate: dayjs().format("DD-MM-YYYY"),
            scheme: null,
            visitType: undefined,
            healthCareId: selectedHospital?.selectedHospital?.value,
            all:
              Number(selectedHospital?.selectedHospital?.value) === -1
                ? "yes"
                : "no",
            pending: true,
            stage: stageId,
          },
          selectedHospital?.selectedHospital?.value,
        );

        setPendingDocs(res?.totalElements);
      }
    } catch (err) {
      //   errorMessage("Please, Try in sometime");
    } finally {
      setIsFetchingPatients(false);
    }
  };

  const fetchPatients = async () => {
    try {
      if (selectedHospital?.selectedHospital?.value) {
        setIsFetchingPatients(true);
        const res: any = await fetchPatientsPL(
          {
            orderBy: "DESC",
            pageNumber: "0",
            pageSize: "10",
            endDate: dayjs().format("DD-MM-YYYY"),
            startDate: dayjs().format("DD-MM-YYYY"),
            scheme: null,
            visitType: undefined,
            healthCareId: selectedHospital?.selectedHospital?.value,
            all:
              Number(selectedHospital?.selectedHospital?.value) === -1
                ? "yes"
                : "no",
          },
          selectedHospital?.selectedHospital?.value,
        );

        setTodayRegistration(res?.totalElements);
        setPatients(res?.patientResponseList || []);
      }
    } catch (err) {
    } finally {
      setIsFetchingPatients(false);
    }
  };

  const handleAddPatient = () => {
    navigate({
      pathname: ROUTES.ADD_PATIENT,
    });
  };

  const handleViewAll = () => {
    navigate({
      pathname: ROUTES.PATIENT_LIST,
    });
  };

  return (
    <HomeScreenComponent
      userName={auth?.userName || "User"}
      todayRegistration={todayRegistration}
      pendingDocs={pendingDocs}
      patients={patients}
      onAddPatient={handleAddPatient}
      handleViewAll={handleViewAll}
      isFetchingPatients={isFetchingPatients}
    />
  );
};

export default HomeScreenContainer;
